import { TransDetailLineItem } from './trans-detail-line-item.model';

export class TransDetail {
  public constructor() {
    this.merchid = '';
    this.account = '';
    this.amount = 0;
    this.currency = '';
    this.retref = '';
    this.respcode = '';
    this.respproc = '';
    this.respstat = '';
    this.resptext = '';
    this.batchid = '';
    this.setlstat = '';
    this.signature = '';
    this.token = '';

    this.InvoiceLineItems = new Array<TransDetailLineItem>();
  }

  public merchid: string;
  public account: string;
  public amount: number;
  public currency: string;
  public retref: string;
  public respcode: string;
  public respproc: string;
  public respstat: string;
  public resptext: string;
  public batchid: string;
  public setlstat: string;
  public signature: string;
  public token: string;

  public InvoiceLineItems: Array<TransDetailLineItem>;
}
